var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"ui_tab clearfix"},_vm._l((_vm.computedItems),function(tabName,index){return _c('li',{key:tabName,class:{ on: index === _vm.value }},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', index)}}},[_vm._v("\n      "+_vm._s(tabName)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }